export const GROUP_REVIEWS_EXPERIMENT_MODES = Object.freeze({
  OFF: 'off',
  AA: 'aa',
  AB: 'ab',
});

export const parseGroupReviewsExperimentMode = (value) => {
  const mode = typeof value === 'undefined' || value === '' ? 'off' : value;
  if (!Object.values(GROUP_REVIEWS_EXPERIMENT_MODES).includes(mode)) {
    throw new Error('GROUP_REVIEWS_EXPERIMENT_MODE must be one of: off, aa, ab');
  }
  return mode;
};

// Fail closed. A routine build without an explicit flag cannot expose the treatment.
export const GROUP_REVIEWS_EXPERIMENT_MODE = parseGroupReviewsExperimentMode(
  process.env.GROUP_REVIEWS_EXPERIMENT_MODE,
);
